import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-card-component',
    template: ` <div class="cmps-card-component-wrapper">
        <div
            class="loading-pause"
            *ngIf="isLoading"
        >
            <div class="loading-spinner"></div>
        </div>

        <div class="cmps-card-component--header">
            <div class="cmps-card-component--header-title">
                <div
                    click-outside
                    (clickOutside)="clickedOutside()"
                >
                    <div class="menu-container">
                        <button cmpsOutlineButton>
                            <h3 cmpsOutlineButtonLabel>{{ cardNameLabel }}</h3>
                        </button>
                        <button
                            class="cmps-icon-button--no-bg"
                            cmpsIconButton
                            [class.no-click]="hasCardLocked"
                            [class.no-options]="disabledDropdown"
                            (click)="$event.stopPropagation(); toggleMenu()"
                        >
                            <cmps-icon
                                [svgIcon]="
                                    hasCardLocked
                                        ? '__internal:lock'
                                        : !isMenuOpened
                                        ? '__internal:chevron-down'
                                        : '__internal:chevron-up'
                                "
                            ></cmps-icon>
                        </button>
                    </div>

                    <div
                        class="cmps-card-component-menu"
                        *ngIf="isMenuOpened"
                    >
                        <ng-container *ngFor="let i of options">
                            <div
                                class="menu-item"
                                (click)="selectedAction.emit(i)"
                            >
                                {{ i }}
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="cmps-card-component--header-action-buttons">
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    *ngIf="hasFilterAction"
                    (click)="filterAction.emit($event)"
                >
                    <cmps-icon svgIcon="__internal:filter"></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    *ngIf="hasRefreshAction"
                    [cmpsTooltipTrigger]="refreshButtonTooltip"
                    (click)="refreshAction.emit($event)"
                >
                    <cmps-icon svgIcon="__internal:refresh"></cmps-icon>
                </button>

                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    *ngIf="hasExpandAction"
                    [cmpsTooltipTrigger]="expandButtonTooltip"
                    (click)="expandAction.emit($event)"
                >
                    <cmps-icon
                        [svgIcon]="
                            !isExpanded
                                ? '__internal:expand'
                                : '__internal:collapse'
                        "
                    ></cmps-icon>
                </button>
            </div>
        </div>
        <hr />
        <div class="cmps-card-component--body">
            <ng-container *ngTemplateOutlet="data"></ng-container>
        </div>
    </div>`,
    host: {
        class: 'cmps-card-component',
        '[class.cmps-card-component--expanded]': 'isExpanded',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCardComponent implements OnDestroy {
    @Input() cardNameLabel: string;
    @Input() isLoading: boolean;
    @Input() hasCardLocked: boolean;
    @Input() disabledDropdown: boolean;

    @Input() hasFilterAction: boolean;
    @Output() filterAction: EventEmitter<MouseEvent | KeyboardEvent>;

    @Input() hasRefreshAction: boolean;
    @Input() refreshButtonTooltip: boolean;
    @Output() refreshAction: EventEmitter<MouseEvent | KeyboardEvent>;

    @Input() hasExpandAction: boolean;
    @Input() isExpanded: boolean;
    @Input() expandButtonTooltip: string;
    @Output() expandAction: EventEmitter<MouseEvent | KeyboardEvent>;

    @Input() options: string[];
    @Input() data: TemplateRef<any> | null;

    @Output() selectedAction: EventEmitter<MouseEvent | KeyboardEvent>;

    isMenuOpened: boolean = false;

    toggleMenu(): void {
        this.isMenuOpened = !this.isMenuOpened;
    }

    clickedOutside(): void {
        this.isMenuOpened = false;
    }

    constructor() {
        this.filterAction = new EventEmitter();
        this.refreshAction = new EventEmitter();
        this.expandAction = new EventEmitter();
        this.selectedAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.filterAction.complete();
        this.refreshAction.complete();
        this.expandAction.complete();
        this.selectedAction.complete();
    }
}
